module.exports = __webpack_public_path__ + "static/media/video-camera-slash-fill.66fe6791.svg";